import React from 'react';
import SwipeableViews from 'react-swipeable-views';
import Button from '@rezdy/components/Button';
import Layout from '@rezdy/components/Layout/DarkCentered';
import QuestionForm, { IOption } from '../QuestionForm';
import Stepper from '../Stepper';
import { IQuestion } from '../../constants/questions';
import { FormContainer, FormContent, FormStepper, FormSummit } from './Styled';
import Grid from '@rezdy/components/Grid';
import Icon from '@rezdy/components/Icon';

interface IKycFromProps {
    questions: IQuestion[];
}

interface IKycState {
    answers: any[];
    selectedView: number;
}

class KycForm extends React.PureComponent<IKycFromProps, IKycState> {
    constructor(props: any) {
        super(props);
        this.state = {
            answers: props.questions.map(() => -1),
            selectedView: 0,
        };
    }

    handleChangeView = (event: any, selectedView: number) => {
        this.handleChangeIndex(selectedView);
    };

    handleChangeIndex = (selectedView: number) => {
        this.setState({
            selectedView,
        });
    };

    onSelect = (option: IOption) => {
        const { selectedView, answers } = this.state;
        const { questions } = this.props;
        let clonedAnswers = [...answers];
        clonedAnswers[selectedView] = option.value;
        if (selectedView + 1 < questions.length) {
            this.setState({
                answers: clonedAnswers,
                selectedView: selectedView + 1,
            });
        } else {
            this.setState(
                {
                    answers: clonedAnswers,
                },
                () => {
                    console.log('submit questions');
                }
            );
        }
    };

    render() {
        const { questions } = this.props;
        const { selectedView } = this.state;
        return (
            <Layout>
                <Grid.Container cols={'auto auto auto'}>
                    <Grid.Cell>
                        {/* make this a component */}
                        <FormContainer>
                            <FormContent>
                                <div style={{ width: 450 }}>
                                    <SwipeableViews
                                        index={selectedView}
                                        onChangeIndex={this.handleChangeIndex}
                                        animateHeight
                                    >
                                        {questions.map((question: IQuestion, index) => (
                                            <div key={`question-${index}`}>
                                                <QuestionForm
                                                    title={question.title}
                                                    options={question.options}
                                                    onSelect={this.onSelect}
                                                    selected={this.state.answers[selectedView]}
                                                />
                                            </div>
                                        ))}
                                    </SwipeableViews>
                                </div>
                            </FormContent>
                            <FormStepper>
                                <Stepper
                                    numberSteps={questions.length}
                                    onChange={this.handleChangeIndex}
                                    value={selectedView}
                                />
                            </FormStepper>
                        </FormContainer>
                    </Grid.Cell>
                    <Grid.Cell alignSelf="end">
                        <FormSummit>
                            <Button action="primary">
                                <Grid.Container cols={2} colGap>
                                    <Grid.Cell>Next</Grid.Cell>
                                    <Grid.Cell>
                                        <Icon name="arrow-right" />
                                    </Grid.Cell>
                                </Grid.Container>
                            </Button>
                        </FormSummit>
                    </Grid.Cell>
                    <Grid.Cell>
                        <img
                            className="logo"
                            alt="Rezdy Booking Software"
                            src="/pic1.png"
                            width="320px"
                            height="100%"
                            style={{ maxHeight: '640px' }}
                        />
                    </Grid.Cell>
                </Grid.Container>
            </Layout>
        );
    }
}

export default KycForm;
